import * as Html from "../../util/Html.ts";
import * as forms from "../../util/forms.js";
import * as i18n from "../../i18n.ts";

export {init}
Html.registerWidget('widget/form/required',{init:init})

function validate(input){
  if(!input.attr('disabled')){
    var 
      isEmptyInputName = input.attr("required-if-empty"),
      isEmptyInput = input.get(0).form[isEmptyInputName];
    if(isEmptyInput && !forms.isEmpty($(isEmptyInput))){
      return true;
    }
    if(input.prop('checked')){
      return true;
    }
    if(forms.isEmpty(input)){
      var key = input.attr("data-fw-form-required-error")||"fw2.fields.requiredError";
      throw new Error(i18n.get(key,input.attr("placeholder")));
    }
  }
  return true;
}

function init(input){
  forms.checkInput(
      input,
      validate
    );
  }